module.exports = __webpack_public_path__ + "img/34.593be007.jpg";